import DE_ADULT_WELCOME_POPUP_PAGE_CONSTANTS from './de'
import EN_ADULT_WELCOME_POPUP_PAGE_CONSTANTS from './en'
import FR_ADULT_WELCOME_POPUP_PAGE_CONSTANTS from './fr'
import HU_ADULT_WELCOME_POPUP_PAGE_CONSTANTS from './hu'
import { T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const ADULT_WELCOME_POPUP_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS> =
  {
    hu: HU_ADULT_WELCOME_POPUP_PAGE_CONSTANTS,
    en: EN_ADULT_WELCOME_POPUP_PAGE_CONSTANTS,
    fr: FR_ADULT_WELCOME_POPUP_PAGE_CONSTANTS,
    de: DE_ADULT_WELCOME_POPUP_PAGE_CONSTANTS
  }

export default ADULT_WELCOME_POPUP_PAGE_CONSTANTS

export const ADULT_WELCOME_POPUP_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS>()
